'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/Tooltip/Tooltip.tsx
import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { twMerge } from "tailwind-merge";
import { useDeviceDetect } from "@wbk/hooks";
import { jsx, jsxs } from "react/jsx-runtime";
var Tooltip = (_a) => {
  var _b = _a, {
    content,
    className,
    defaultOpen,
    open,
    onOpenChange,
    delayDuration = 300,
    disableHoverableContent,
    arrow = true,
    children
  } = _b, props = __objRest(_b, [
    "content",
    "className",
    "defaultOpen",
    "open",
    "onOpenChange",
    "delayDuration",
    "disableHoverableContent",
    "arrow",
    "children"
  ]);
  const { isMobile } = useDeviceDetect();
  const [internalOpen, setInternalOpen] = React.useState(defaultOpen);
  const isControlled = open !== void 0;
  return /* @__PURE__ */ jsx(TooltipPrimitive.Provider, { children: /* @__PURE__ */ jsxs(
    TooltipPrimitive.Root,
    {
      defaultOpen,
      open: isControlled ? open : internalOpen,
      onOpenChange: (isOpened) => {
        if (!isControlled) {
          setInternalOpen(isOpened);
        }
        onOpenChange == null ? void 0 : onOpenChange(isOpened);
      },
      delayDuration,
      disableHoverableContent,
      children: [
        /* @__PURE__ */ jsx(
          TooltipPrimitive.Trigger,
          {
            onClick: () => {
              if (!isMobile) return;
              if (!isControlled) {
                setInternalOpen(!internalOpen);
              }
              onOpenChange == null ? void 0 : onOpenChange(!internalOpen);
            },
            asChild: true,
            children
          }
        ),
        /* @__PURE__ */ jsxs(
          TooltipPrimitive.Content,
          __spreadProps(__spreadValues({
            className: twMerge(
              "bg-input-popover animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 rounded-S z-50 w-auto max-w-xs p-2",
              className
            ),
            sideOffset: 4
          }, props), {
            children: [
              content,
              arrow && /* @__PURE__ */ jsx(TooltipPrimitive.Arrow, { className: "fill-input-popover" })
            ]
          })
        )
      ]
    }
  ) });
};
var Tooltip_default = Tooltip;

export {
  Tooltip_default
};
//# sourceMappingURL=chunk-FPQA6X72.mjs.map